import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const newKey = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
api.interceptors.request.use((c) => {
  const m = (c.method || "get").toLowerCase();
  if (m !== "get" && !String(c.url).includes("/auth/")) {
    c.headers = c.headers || {};
    if (!c.headers["Idempotency-Key"]) c.headers["Idempotency-Key"] = newKey();
  }
  return c;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config || {};
    if (!error.response && orig.headers?.["Idempotency-Key"] && !orig._netRetry) {
      orig._netRetry = true;
      await new Promise((r) => setTimeout(r, 1500));
      return api(orig);
    }
    if (error.response?.status === 401 && !orig._retry && !String(orig.url).includes("/auth/")) {
      orig._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(orig);
      } catch (e) {
        window.dispatchEvent(new Event("auth:logout"));
      }
    }
    return Promise.reject(error);
  }
);

export const isConflict = (e) => e?.response?.status === 409 && e?.response?.data?.detail?.code === "edit_conflict";

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export async function downloadFile(path, params = {}, fallback = "export.xlsx") {
  const res = await api.get(path, { params, responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const name = (cd.match(/filename="(.+)"/) || [])[1] || fallback;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}

export const downloadExport = (kind, params = {}) => downloadFile(`/export/${kind}`, params, `${kind}.xlsx`);

export const notifyStockChanged = () => window.dispatchEvent(new Event("stock:changed"));
